
import React from "react";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NoStaffView: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="text-center py-12">
      <div className="mx-auto bg-muted/30 w-16 h-16 rounded-full flex items-center justify-center mb-4">
        <UserPlus className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="text-xl font-medium mb-2">No AI staff members</h3>
      <p className="text-muted-foreground mb-6">You haven't hired any AI staff members yet.</p>
      <Button onClick={() => navigate("/staff")}>
        Hire AI Staff
      </Button>
    </div>
  );
};

export default NoStaffView;
